// client/src/services/recurrenceApi.js
// Recurring events (On-Screen 2.0). Occurrences are real events linked by series_id.

import axios from 'axios';

const BASE = (process.env.REACT_APP_BASE_URL || '').replace(/\/+$/, '');
const evUrl = (tenantId, eventId) => `${BASE}/api/events/${tenantId}/events/${eventId}`;

export async function createRecurrence(tenantId, eventId, rule) {
  const { data } = await axios.post(`${evUrl(tenantId, eventId)}/recurrence`, rule, { withCredentials: true });
  return data;
}

export async function getSeries(tenantId, eventId) {
  const { data } = await axios.get(`${evUrl(tenantId, eventId)}/series`, { withCredentials: true });
  return data;
}

export async function applySeriesEdit(tenantId, eventId, scope, fields) {
  const { data } = await axios.patch(`${evUrl(tenantId, eventId)}/series/apply`, { scope, fields }, { withCredentials: true });
  return data;
}

export async function deleteRecurrence(tenantId, eventId, scope = 'following') {
  const { data } = await axios.delete(`${evUrl(tenantId, eventId)}/recurrence?scope=${scope}`, { withCredentials: true });
  return data;
}

export const RECURRENCE_FREQS = [
  { value: 'daily', label: 'Every day' },
  { value: 'weekly', label: 'Every week' },
  { value: 'biweekly', label: 'Every 2 weeks' },
  { value: 'monthly', label: 'Every month' },
];

export const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
